<template>
    <section class="section mod-block" :class="className" id="najblizsze-sniadania">
        <div class="container">
            <div class="columns is-centered">
                <div class="column is-10 has-text-centered">
                    <h2 class="title has-text-centered">{{ data.title }}</h2>
                    <div class="content">
                        <p v-html="data.content"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="columns is-multiline is-centered">
                <div
                    class="column is-12 card card-city"
                    :class="{'is-offset-1':key > 0}"
                    v-for="(city,key) in cities"
                >
                    <!-- <div class="card-city__header">
                        <img :src="city.image" :alt="city.name">
                        <h3 class="title" v-html="city.name"></h3>
                    </div> -->
                    <div
                        class="card-city__category"
                        v-for="post in posts"
                    >
                        <div class="card-city__title">
                            <!-- <span>{{ printDate(post.acf.data) }}</span> -->
                            <h4 class="title">{{ post.title.rendered }}</h4>
                        </div>
                        <ul class="card-city__feature">
                            <li v-for="topic in post.acf.topics">
                                <a
                                    href.prevent="#"
                                    @click="$router.push('/'+$t('url-challenges')+'/'+topic.post_name)"
                                >
                                    {{ topic.post_title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
    data(){
        return {
            cats: Object,
            posts: Object,
            showContent: false,
            cities: [
                {
                    slug: 'warszawa',
                    name: 'Warszawa / Poznań',
                    image: '../img/card-header-warszawa.png'
                },
                // {
                //     slug: 'poznan',
                //     name: 'Poznań<br /><span>(wideokonferencja z Warszawą)</span>',
                //     image: '../img/card-header-poznan.png'
                // }
            ]
        }
    },
    methods:{
        printDate(date){
            let m = moment(date)
            m.locale('pl')
            return m.format('LLL')
        },
        load(cat,target){
            axios.get(process.env.VUE_APP_API+'wp-json/wp/v2/sniadania/?per_page=30&orderby=menu_order&order=asc')
            .then((response) => {
                this.posts = response.data
                this.showContent = true
            })
            .catch((error) => {
                console.log(error)
            })
        }
    },
    created() {
        this.load()
    }
}
</script>

<style lang="sass">
@import "@/styles/framework/variables.sass"
@import "@/styles/framework/extends.sass"
.flex-home-sniadania
    background-color: $grey2
    .card
        padding: 0
.title
    color: $pink
    text-align: left
.card-city
    $this: &
    cursor: default
    margin-top: 6rem
    &:nth-child(even)
        .card-city__category
            > .title
                background-color: $blue3
    &__header
        display: flex
        align-items: center
        flex-direction: row
        img
            margin-top: -47px
            display: block
        .title
            font-weight: normal
            position: absolute
            right: 4rem
            color: $white
            text-align: right
            span
                font-size: $size-5

    &__category
        border-bottom: 1px solid $grey1
        padding: 1rem 0
        // &:hover
        //     background-color: $grey2
    &__title
        padding: 0.5rem 5rem 0.5rem 1rem
        margin-bottom: 0
        position: relative
        .title, span
        text-align: left
        span
            font-size: $size-6
            font-weight: normal
            color: $grey3
        .title
            color: $pink
            text-align: left
            font-weight: normal
            font-size: $size-5
        &:after
            content: " "
            position: absolute
            top: 0
            right: 1rem
            width: 100%
            height: 100%
            // background-image: url('../../assets/arrow-grey.svg')
            background-size: 6% auto
            background-repeat: no-repeat
            background-position: center right
    &__feature
        transition: background-color $normal
        position: relative
        &:last-child
            border: 0
            a
                color: $blue2
                transition: color $normal
                &:hover
                    color: $blue1
        .title
            font-weight: normal
            text-align: left
            color: $blue1
            font-size: $size-6
</style>
